import React from "react";
import {FaSolidIcon} from "../../components/FontAwesomeIcons";
import ModalPortalHOC from "../../components/BaseComponents/ModalPortalHOC";
import {GoogleCalendarPage} from "./GoogleCalendarPage";
import googleCalendarIcon from "./../../img/brands/google-calendar-icon.svg";
import AuthAPI from "../../api/AuthAPI";
import FuxEvents from "../../lib/FuxFramework/FuxEvents";
import {AUTHENTICATED_USER_DATA_CHANGE} from "../../const/AppEventsCostants";

export class GoogleCalendarBanner extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false
        };
        this.bannerStyle = {
            background: "linear-gradient(to right top, #293069, #383d78, #474a87, #565896, #6566a6, #7373b3, #8180bf, #8f8dcc, #9f9cd9, #aface5, #bfbcf2, #cfccff)",
            color: "#ffffff"
        };
        this.iconWrapperStyle = {
            width: 48,
            height: 48
        };
    }

    handleOpen = _ => this.setState({pageOpen: true});

    handleClose = _ => this.setState({pageOpen: false});

    handleBannerKeyDown = event => {
        if (event.key === "Enter" || event.key === " ") {
            event.preventDefault();
            this.handleOpen();
        }
    }

    handleDefaultChange = _ => {
        AuthAPI.currentUser = {...AuthAPI.currentUser, has_default_google_calendar: true};
        FuxEvents.emit(AUTHENTICATED_USER_DATA_CHANGE)
    }

    render() {
        return (
            <React.Fragment>
                <div
                    style={this.bannerStyle}
                    className={"rounded shadow-sm p-3 d-flex align-items-center justify-content-between"}
                    role={"button"}
                    tabIndex={0}
                    onClick={this.handleOpen}
                    onKeyDown={this.handleBannerKeyDown}
                >
                    <div className={"d-flex align-items-center"}>
                        <img src={googleCalendarIcon} height={50}/>
                        <div className={"ml-3"}>
                            <div className={"font-weight-bold"}>Sincronizza Google Calendar</div>
                            <div className={"small"}>Sfrutta Bookizon plus e sincronizza le tue prenotazioni su Google
                                Calendar
                            </div>
                        </div>
                    </div>
                    <div className={"small text-uppercase font-weight-bold"}>
                        <FaSolidIcon name={"chevron-right"}/>
                    </div>
                </div>
                {
                    this.state.pageOpen &&
                    <ModalPortalHOC>
                        <GoogleCalendarPage active={this.state.pageOpen} onDismiss={this.handleClose}
                                            onDefaultChange={this.handleDefaultChange}/>
                    </ModalPortalHOC>
                }
            </React.Fragment>
        );
    }
}
